/* MV21 theme integration, isolated from the search app's managed assets. */
(() => {
  'use strict';
  function placeGuide() {
    const guide = document.querySelector('[data-mv21-collection-guide]');
    const description = document.querySelector('.moto21-collection-description--short');
    if (!guide || !description || guide.previousElementSibling === description) return;
    const source = guide.closest('.mv21-collection-guides-section');
    description.after(guide);
    if (source) source.hidden = true;
  }
  placeGuide();
  // The app may mount after the theme scripts; observe only while waiting.
  if (document.querySelector('[data-mv21-collection-guide]') && !document.querySelector('.moto21-collection-description--short')) {
    const observer = new MutationObserver(() => {
      if (document.querySelector('.moto21-collection-description--short')) { placeGuide(); observer.disconnect(); }
    });
    observer.observe(document.body, {childList: true, subtree: true});
    setTimeout(() => observer.disconnect(), 15000);
  }
  document.addEventListener('shopify:section:load', placeGuide);

  // Same-origin Garage iframe: keep this enhancement scoped to this theme.
  if (!location.pathname.includes('/pages/mv21-garaza')) return;
  const boundDocs = new WeakSet();
  function enableSwipe(doc) {
    if (boundDocs.has(doc)) return;
    boundDocs.add(doc);
    let start = null, suppressClickUntil = 0;
    doc.addEventListener('touchstart', event => {
      const stage = event.target.closest?.('.photo-stage, .photo-open');
      if (!stage || event.touches.length !== 1 || stage.classList.contains('zoomed')) { start = null; return; }
      const touch = event.touches[0];
      start = {x:touch.clientX,y:touch.clientY,time:Date.now(),stage};
    }, {passive:true});
    doc.addEventListener('touchmove', event => { if (event.touches.length !== 1) start = null; }, {passive:true});
    doc.addEventListener('touchcancel', () => { start = null; }, {passive:true});
    doc.addEventListener('touchend', event => {
      const from = start; start = null;
      if (!from || event.changedTouches.length !== 1 || Date.now()-from.time > 900 || from.stage.classList.contains('zoomed')) return;
      const touch = event.changedTouches[0], dx = touch.clientX-from.x, dy = touch.clientY-from.y;
      if (Math.abs(dx)<45 || Math.abs(dx)<Math.abs(dy)*1.5) return;
      suppressClickUntil = Date.now()+500;
      if (from.stage.matches('.photo-stage')) {
        const button=from.stage.closest('dialog')?.querySelector(dx<0?'[data-next]':'[data-prev]');
        if (button && !button.disabled) button.click();
      } else {
        const thumbs=Array.from(doc.querySelectorAll('.gallery-thumbs [data-photo]'));
        const index=thumbs.findIndex(button=>button.getAttribute('aria-pressed')==='true');
        const next=thumbs[index+(dx<0?1:-1)];
        if (next) next.click();
      }
    }, {passive:true});
    doc.addEventListener('click', event => {
      if (Date.now()<suppressClickUntil && event.target.closest?.('.photo-open,.photo-stage')) {
        event.preventDefault(); event.stopImmediatePropagation();
      }
    }, true);
  }
  enableSwipe(document); // Fullscreen viewer is rendered into the parent document.
  function bindFrames() {
    document.querySelectorAll('iframe').forEach(frame => {
      if (!frame.src.includes('/apps/mv21-garage')) return;
      const bind=()=>{try { if (frame.contentDocument) enableSwipe(frame.contentDocument); } catch (_) { /* Cross-origin frames remain untouched. */ }};
      bind();
      if (!frame.dataset.mv21SwipeBound) { frame.dataset.mv21SwipeBound='true'; frame.addEventListener('load',bind); }
    });
  }
  bindFrames();
  const frames=new MutationObserver(bindFrames);
  frames.observe(document.body,{childList:true,subtree:true});
})();
